import { sendEvent } from '~~/common/js/client/analytics';

export const IMPRESSION = 'search_result_impression';
export const CLICK = 'search_result_click';
export const TYPE_AD = 'ad-text';
export const TYPE_DEEP_LINK = 'deep-link';
export const TYPE_PRODUCT_AD = 'product-ad';
export const TYPE_RELATED_SEARCH = 'related-search';
export const TYPE_WEB = 'organic';

const VERTICAL_IMAGES = 'images';
const VERTICAL_WEB = 'web';

// maps URL paths to verticals
const verticalsMap = {
  '/search': VERTICAL_WEB,
  '/images': VERTICAL_IMAGES,
};

const getVertical = () => verticalsMap[location?.pathname] ?? VERTICAL_WEB;

// It is slightly inefficient to do this every time trackImpression is called
// but to improve separation of concerns I decided not to force every caller
// to provide the query themselves and rather encapsulate the logic here.
const getQuery = () => {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get('q') ?? '';
};

const serialiseExtensions = (extensions = []) => extensions.map((extension) => extension.type).join(',');

const trackEvent = (eventName) => ({ type, url, title, position, rank, label = '', extensions }) => {
  sendEvent(
    eventName,
    {
      extensions: serialiseExtensions(extensions),
      label,
      position,
      query: getQuery(),
      rank,
      title,
      type,
      url,
      vertical: getVertical(),
    },
  );
};

export const trackImpression = trackEvent(IMPRESSION);
export const trackClick = trackEvent(CLICK);
